import React from "react";
import useLayerPagination from "./useLayerPagination";
import RedirectToPageOne from "./RedirectToPageOne";
import Paginator from "theme/components/molecules/Paginator";

const LayerPagination = ({ layer }) => {
  const [page, maxPage, location] = useLayerPagination(layer);

  if (maxPage === 0) {
    return null;
  }
  if (page > maxPage) {
    return <RedirectToPageOne location={location} />;
  }
  return <Paginator maxPage={maxPage} page={page} location={location} />;
};

export default LayerPagination;
